/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IUserSubprofileModel } from "@nf/common";

import styles from "./ProfileAvatar.module.scss";

export interface ProfileAvatarProps {
  profile: IUserSubprofileModel;
}

export const ProfileAvatar = ({ profile }: ProfileAvatarProps) => {
  return (
    <div className={styles.profile}>
      <div
        className={styles.avatar}
        style={{
          backgroundColor: profile.Color,
        }}
      />
      <div className={styles.username}>{profile?.FirstLetter}</div>
    </div>
  );
};

export default ProfileAvatar;
